export default __webpack_public_path__ + "static/media/couple@3x.5e40b418.png";